import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { isAdmin } from '../actions/profile/UserActions';

const AnalyticsTracker = ({ location }) => {
  useEffect(() => {
    if (!isAdmin()) ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return null; // this component only tracks, nothing to render
};

export default withRouter(AnalyticsTracker);